/**
 * Oath Location Service
 * API calls for location data (states, etc.)
 */

import { OathStorageKeys } from '../models/userModels';
import { oathRefreshToken } from './oathAuthService';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem(OathStorageKeys.JWT_TOKEN);
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};

const authFetch = async (url, options = {}) => {
  let response = await fetch(url, { ...options, headers: { ...getAuthHeaders(), ...options.headers } });
  if (response.status === 401) {
    const refreshResult = await oathRefreshToken();
    if (refreshResult.success) {
      response = await fetch(url, { ...options, headers: { ...getAuthHeaders(), ...options.headers } });
    }
  }
  return response;
};

// In-memory cache
let statesCache = null;

/**
 * Get all US states from the backend
 * Cached after first successful fetch
 * @returns {Promise<{success: boolean, data?: Array<{stateCd: string, stateName: string}>, error?: string}>}
 */
export const getAllStates = async () => {
  if (statesCache) return { success: true, data: statesCache };

  try {
    const response = await authFetch(`${BASE_URL}oath/location/all-states`);

    if (!response.ok) {
      return { success: false, error: 'Failed to load states' };
    }

    const data = await response.json();
    const states = data.result || data;
    statesCache = states;
    return { success: true, data: states };
  } catch (error) {
    console.error('Error fetching states:', error);
    return { success: false, error: 'Network error loading states' };
  }
};
